import SimilarCard from "./similar-card";
import Carousel from "react-multi-carousel";
import "./style.css";

const villa = {
  image: "https://source.unsplash.com/800x500/?villa",
  name: "Luxury Villa",
  address: "123 Main St, City, Country",
  rating: 4.5,
  landmark: "Nearby Landmark",
  price: "Starting from 4250 Rs per room/night",
};

const SimilarProperties = ({
  data,
  location,
  adults,
  children,
  startDate,
  endDate,
  landmark
}) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
  return (
    <div className="flex justify-center font-sans mt-2 mb-12">
      <div className="p-4 w-[90vw] bg-[#f1f1f1]  border-[1px] rounded-lg shadow-lg ">
        <div className="text-[20px] font-semibold mb-4 ml-4 ">
          Similar Villas near this Landmark
        </div>
        <Carousel
          responsive={responsive}
          infinite={true}
          showDots={true}
          removeArrowOnDeviceType={["tablet", "mobile"]}
          transitionDuration={2000}
        >
          {data.map((a) => (
            <div className="flex justify-center mb-8">
              <SimilarCard
                villadata={a}
                location={location}
                adults={adults}
                children={children}
                startDate={startDate}
                endDate={endDate}
                landmark={landmark}
              />{" "}
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default SimilarProperties;
